export const SEARCH_THRESHOLD = 8;

export const SECTION_DIVIDER_KEY = 'section-divider';
